import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  MenuItem,
  Button,
  Box,
  Typography,
  Divider,
  List,
  ListItemButton,
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useAtomValue } from 'jotai';
import { activityOutcomesAtom } from '../../../Atoms';
import { ColumnFlexBox } from '../../../Components/FlexBox';
import { formatPayloadDate } from '../../../Helpers/dates';
import DateRangeField from '../../../Components/Inputs/DateRangeField';

const PracticeFilters = function PracticeFilters({
  onChangeFilters,
  defaultValue = {},
  onClose = () => {},
}) {
  const intl = useIntl();

  const activityOutcomes = useAtomValue(activityOutcomesAtom);
  const PRACTICE_STATUSES = activityOutcomes.DOSSIER.map(({ name }) => name);

  const [selectedStatus, setSelectedStatus] = useState(
    defaultValue?.practiceState
  );
  const [dateLoadingPractice, setDateLoadingPractice] = useState(
    defaultValue?.dateLoadingPractice || [null, null]
  );
  const [liquidationDate, setLiquidationDate] = useState(
    defaultValue?.liquidationDate || [null, null]
  );

  const handleChangeSelectedStatus = (event, newStatus) => {
    //selectedStatus can be null if clicks on already selected status
    if (newStatus === selectedStatus) setSelectedStatus(null);
    else setSelectedStatus(newStatus);
  };

  const handleConfirm = () => {
    onChangeFilters({
      selectedStatus,
      dateLoadingPractice: dateLoadingPractice?.[0]
        ? dateLoadingPractice?.map((date) =>
            formatPayloadDate(date)?.toISOString()
          )
        : undefined,
      liquidationDate: liquidationDate?.[0]
        ? liquidationDate?.map((date) => formatPayloadDate(date)?.toISOString())
        : undefined,
    });
    onClose();
  };

  return (
    <ColumnFlexBox gap="16px" minWidth="300px">
      <Typography variant="subtitle1">{intl.messages.STATUS}</Typography>
      <List>
        {PRACTICE_STATUSES.map((status) => (
          <ListItemButton
            disableGutters
            sx={{
              display: 'flex',
              pr: '2px',
              pl: '8px',
              justifyContent: 'space-between',
              borderRadius: '5px',
              color: (theme) =>
                selectedStatus === status && theme.palette.primary.main,
              '&.Mui-selected': {
                background: 'white.main',
                fontWeight: 'bold',
              },
            }}
            key={status}
            selected={selectedStatus === status}
            onClick={(e) => handleChangeSelectedStatus(e, status)}
          >
            {intl.messages[status] || status}
            {status === selectedStatus && <CheckIcon />}
          </ListItemButton>
        ))}
      </List>
      <Divider />
      <DateRangeField
        id="loading-date-range"
        label={intl.messages.LOADING_DATE}
        value={dateLoadingPractice}
        onChange={setDateLoadingPractice}
      />
      <DateRangeField
        id="liquidation-date-range"
        label={intl.messages.LIQUIDATION_DATE}
        value={liquidationDate}
        onChange={setLiquidationDate}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          position: 'sticky',
          bottom: 0,
          pt: '16px',
        }}
      >
        <Button id="confirm-filters-btn" size="large" onClick={handleConfirm}>
          {intl.messages.CONFIRM}
        </Button>
      </Box>
    </ColumnFlexBox>
  );
};

PracticeFilters.propTypes = {
  onChangeFilters: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  onClose: PropTypes.func,
};

export default PracticeFilters;
